/*
 * Global themeing
 *
 * Naming convention: [target]_[property]_[variation]_[state]
 *
 * Eventually we will let individual clients override these,
 * but this will still serve as a baseline
 * Please refer to https://mineral-ui.com/theming for all possible variables
 * as well as below for any new ones introduced
 *
 * Also, when carriers can customize the color to be anything, we will
 * have to remove the hardcoding of text colors. It looks like Mineral UI uses
 * https://polished.js.org/docs/#readablecolor to determine the best readable color?
 * The palette also has an inflection point, but I am not sure what that is used for.
 * I suspect there build theme function uses it. We might also be able to use Typography
 * colors defined.
 */

const Background = {
  backgroundColor_hover: '#f5f7f8',
  backgroundColor_page: '#f5f7f8',
};

const Border = {
  borderColor: '#dfe3e8',
};

const GlobalBaseTheme = {
  ...Background,
  ...Border,
};

export default GlobalBaseTheme;
